/*
 * Auth Messages
 *
 * This contains all the text for the Auth component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'app.components.Auth.login',
    defaultMessage: 'Sign in on RunnerMaps',
  },
  intro: {
    id: 'app.components.Auth.intro',
    defaultMessage:
      'You can sign in using Google, Facebook, or with your email address. If you sign in with your email address, you will receive a message to confirm the address.',
  },
  submitted: {
    id: 'app.components.Auth.submitted',
    defaultMessage:
      "An email message has been sent to '{email}'. Click on the link in the message to continue.",
  },
  emailSignIn: {
    id: 'app.components.Auth.emailSignIn',
    defaultMessage: 'Sign in with email',
  },
  noEmail: {
    id: 'app.components.Auth.noEmail',
    defaultMessage: 'No email provided, try another signin method',
  },
  email: {
    id: 'app.components.AskEmail.email',
    defaultMessage: 'Email address',
  },
  notVerified: {
    id: 'app.components.Auth.notVerified',
    defaultMessage:
      'Your email address is not verified, so you cannot sign in with it. Sign in with Google, or with a link sent to your email address.',
  },
  loginFailed: {
    id: 'app.components.Auth.loginFailed',
    defaultMessage:
      'Signing in to RunnerMaps failed, probably because of a connection problem. Use "Retry sign-in" at the top of the page to try again.',
  },
  error: {
    id: 'app.components.Auth.error',
    defaultMessage:
      'Error in authentication, try again or try another signin method',
  },
});
